<div *ngIf="sMenu" class="sidebar" [ngStyle]="{ display: activateGlobalNav ? 'none' : 'block' }">
  <div class="back-link" *ngIf="!isResponsiveScreen && sMenu.navigationMenuTitle">
    <a [routerLink]="sMenu.navigationMenuPath">
      <button-icon iconattributes="-xsm" [icon]="'singlearrow-left'" class="navigation-back-icon"></button-icon>
      <span class="navigation-title">{{ sMenu.navigationMenuTitle }}</span>
    </a>
  </div>
  <div class="back-link" *ngIf="isResponsiveScreen && getBackTitle()" (click)="goBack()">
    <button-icon class="navigation-back-icon" iconattributes="-xsm"
      [icon]="'singlearrow-left'"></button-icon>
    <span class="navigation-responsive-title">{{ getBackTitle() }}</span>
  </div>
  <div class="section-heading" *ngIf="isResponsiveScreen && previousMenus.length > 0 && sMenu.title">
    <span class="item-title">{{ sMenu.title }}</span>
  </div>
  <ng-container *ngFor="let section of sMenu.children">
    <div class="category-container"
      [ngClass]="{'drilled-category' : isResponsiveScreen && isToggled}">
      <div class="category">
        <span *ngIf="(!section.path && !isResponsiveScreen) || !isToggled">{{ section.title }}</span>
        <app-link *ngIf="section.path && isToggled" class="category-link" [to]="section.path"
          [disableRoute]="!section.path">
          <lucide-icon *ngIf="section.icon" [name]="section.icon" class="lucide-icon"></lucide-icon>
          <span class="category-link-title">{{ section.title }}</span>
        </app-link>
      </div>
      <ul class="section-items parent-category">
        <ng-container
          *ngTemplateOutlet="renderItems; context: { items: section.children }"></ng-container>
      </ul>
    </div>
  </ng-container>
  <ng-template #renderItems let-items="items">
    <ng-container *ngFor="let item of items">
      <li>
        <div class="item-row" [ngClass]="{ 'expandable': item.children }"
          (click)="item.children && toggle(item, $event)">
          <app-link *ngIf="item.path" class="item-link" [to]="item.path" [disableRoute]="!item.path"
            (click)="onSelectGrandchild(item, $event)">
            <lucide-icon *ngIf="item.icon" [name]="item.icon" class="lucide-icon"></lucide-icon>
            <span class="item-title" [ngClass]="getTitleClass(item)">
              {{ item.title }}
            </span>
          </app-link>
          <span *ngIf="!item.path && item.children" class="item-title has-children"
            [ngClass]="[getTitleClass(item), item.expanded ? 'expanded' : '']">
            {{ item.title }}
          </span>
          <button-icon class="category-icon" *ngIf="item.children" iconattributes="-xsm"
            [icon]="item.expanded ? 'dropdown' : 'singlearrow-right'"
            (click)="toggle(item, $event)">
          </button-icon>
        </div>
        <ul *ngIf="item.expanded && item.children" class="child-items">
          <ng-container
            *ngTemplateOutlet="renderItems; context: { items: item.children }"></ng-container>
        </ul>
      </li>
    </ng-container>
  </ng-template>
</div>

<div class="global-nav-container" *ngIf="activateGlobalNav" [ngStyle]="{ display: activateGlobalNav ? 'block' : 'none' }">
  <app-nav-container
     [menu]="globalNav"
     [userName]="userName"
     [userMail]="userMail"
     [isUserLoggedIn]="isUserLoggedIn"
  ></app-nav-container>
</div>
